import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
       loadingSalesWebLeads: false,
       salesWebLeads: [],
       loadingSingleSalesWebLead: false,
       singleSalesWebLead: {}
    }),
    mutations: {
      setLoadingSalesWebLeads(state, item) {
        state.loadingSalesWebLeads = item
      },
      setloadingSingleSalesWebLead(state, item) {
        state.loadingSingleSalesWebLead = item
      },
      loadSalesWebLeads(state, items) {
        if (items.length > 0) {
          items.forEach(function (item) {
            item.client_details = JSON.parse(item.client_details);
            item.extra_details = JSON.parse(item.extra_details);
            item.products = JSON.parse(item.products);
          });
        }
        state.salesWebLeads = items;
      },
      loadSingleSalesWebLead(state, item) {
        if (item.client_details) {
          item.client_details = JSON.parse(item.client_details);
        }
        if (item.extra_details) {
          item.extra_details = JSON.parse(item.extra_details);
        }
        if (item.products) {
          item.products = JSON.parse(item.products);
        }
        state.singleSalesWebLead = item
      },
      removeWebLead(state, leadId) {
        const webLeadIdx = state.salesWebLeads.findIndex(lead => lead.id === leadId)
        if (webLeadIdx !== -1) {
          state.salesWebLeads.splice(webLeadIdx, 1)
        } 
      },
      updateSalesWebLeadAgent(state, payload) {
        const webLead = state.salesWebLeads.find(lead => lead.id === payload.leadId)
        if (webLead) {
          webLead.assigned_agent_id = payload.assigned_agent_id
          webLead.agent = payload.agentName
        }
      }
    },
    actions: {
      fetchSalesWebLeads({ commit, rootGetters }, leadStatus) {
        const user = rootGetters.loggedUser;
        let url = process.env.VUE_APP_HUB_API_HOST + `api/cereri-vanzari/all/${leadStatus}`;

        if (["agent"].includes(user.rol) && user.departament == 'vanzari') {
          url += "/" + user.id_user
        }

        commit("setLoadingSalesWebLeads", true);
        Vue.http.get(url, {
            headers: headers
          })
          .then(response => {
            commit("loadSalesWebLeads", response.data);
            commit("setLoadingSalesWebLeads", false);
          })
          .catch(error => {
            console.log(error);
            commit("setLoadingSalesWebLeads", false);
          });
      },
      fetchSingleSalesWebLead({ commit }, leadId) {
        commit("setloadingSingleSalesWebLead", true);

        let url = process.env.VUE_APP_HUB_API_HOST + "api/cereri-vanzari/single/" + leadId;

        Vue.http.get(url, {
          headers: headers
        })
        .then(response => {
          commit("loadSingleSalesWebLead", response.data);
          commit("setloadingSingleSalesWebLead", false);
        })
        .catch(error => {
          console.log(error);
          commit("setloadingSingleSalesWebLead", false);
        });
      },
      changeSalesWebLeadStatus({ commit }, payload) {
        commit("setloadingSingleSalesWebLead", true);
        Vue.http.put(process.env.VUE_APP_HUB_API_HOST + "api/cereri-vanzari/single/edit", payload, {
            headers: headers
          })
          .then(response => {
            router.push({ query: M.toast( { html: response.body, classes: "bg-green-500" }) });
            commit("removeWebLead", payload.lead_id)
            commit("setloadingSingleSalesWebLead", false);
          })
          .catch(error => {
            console.log(error);
            commit("setloadingSingleSalesWebLead", false);
          });
      },
      updateSalesWebLeadAgent({ commit }, payload) {
        commit("setloadingSingleSalesWebLead", true);
        Vue.http.put(process.env.VUE_APP_HUB_API_HOST + "api/cereri-vanzari/single/change-agent", payload, {
            headers: headers
          })
          .then(response => {
            commit("updateSalesWebLeadAgent", payload)
            router.push({ query: M.toast( { html: response.body, classes: "bg-green-500" }) });
            commit("setloadingSingleSalesWebLead", false);
          })
          .catch(error => {
            console.log(error);
            commit("setloadingSingleSalesWebLead", false);
          });
      }
    }
}